export const MOH_ENDPOINTS = {
  // Playlists
  PLAYLISTS_LIST: (pbxId: number) => `/app/v1/pbxes/${pbxId}/playlists/`,
  PLAYLIST_DETAIL: (id: number) => `/app/v1/playlists/${id}/`,
  PLAYLIST_DEFAULT: (pbxId: number) =>
    `/app/v1/pbxes/${pbxId}/playlists/default/`,

  // Audio Tracks
  AUDIO_TRACKS_LIST: (pbxId: number) => `/app/v1/pbxes/${pbxId}/audio-tracks/`,
  AUDIO_TRACK_DETAIL: (pbxId: number, uuid: string) =>
    `/app/v1/pbxes/${pbxId}/audio-tracks/${uuid}/`,

  // Playlist-AudioTrack associations
  PLAYLIST_ADD_TRACK: (playlistId: number) =>
    `/app/v1/playlists/${playlistId}/audio-tracks/`,
  PLAYLIST_REMOVE_TRACK: (playlistId: number, audioTrackId: number) =>
    `/app/v1/playlists/${playlistId}/audio-tracks/${audioTrackId}/`,
} as const
